import { ProgramRequestStatus } from "../../../models/ProgramRequest/ProgramRequestStatus";

export const isAsooOnlyStatusForMinisterFlow = (status: ProgramRequestStatus) => {
  switch (status) {
    case ProgramRequestStatus.SubmittedASOO:
    case ProgramRequestStatus.HarmonizationASOO:
    case ProgramRequestStatus.UnlockedASOO:
    case ProgramRequestStatus.CancelledASOO:
    case ProgramRequestStatus.RejectedASOO:
    case ProgramRequestStatus.RejectedHarmonizationASOO:
    case ProgramRequestStatus.ArchivedASOO:
    case ProgramRequestStatus.ConsentASOO:
      return true;
    default:
      return false;
  }
};

